module.exports = {
          srcSet: __webpack_public_path__ + "16cf1b9037d00b3958e63eaee160513b-24.png"+" 24w",
          images:[ {path: __webpack_public_path__ + "16cf1b9037d00b3958e63eaee160513b-24.png",width: 24,height: 24}],
          src: __webpack_public_path__ + "16cf1b9037d00b3958e63eaee160513b-24.png",
          toString:function(){return __webpack_public_path__ + "16cf1b9037d00b3958e63eaee160513b-24.png"},
          
          width: 24,
          height: 24
        }